import { __awaiter, __generator, __read } from "tslib";
import axios from 'axios';
import useSWRImmutable from 'swr/immutable';
var nutsPadding = function (parentsLength) {
    switch (parentsLength) {
        case 1:
            return '2rem';
        case 2:
            return '4rem';
        case 3:
            return '6rem';
        case 4:
            return '8rem';
        case 5:
            return '12rem';
        default:
            return '';
    }
};
var fetcher = function (_a) {
    var url = _a.url, disableTopLevelNuts = _a.disableTopLevelNuts, disableAllButNUTS3 = _a.disableAllButNUTS3;
    return axios.get(url).then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Object.entries(res.data).map(function (entry) {
                    var _a = __read(entry, 2), code = _a[0], _b = _a[1], description = _b.description, parents = _b.parents;
                    return {
                        label: "".concat(description, " (").concat(code, ")"),
                        value: code,
                        paddingLeft: nutsPadding(parents.length),
                        isDisabled: (disableTopLevelNuts && code.length === 2) ||
                            (disableAllButNUTS3 && code.length !== 5),
                    };
                })];
        });
    }); });
};
export var useFetchNuts = function (url, disableTopLevelNuts, disableAllButNUTS3) {
    var _a = useSWRImmutable({ url: url, disableTopLevelNuts: disableTopLevelNuts, disableAllButNUTS3: disableAllButNUTS3 }, fetcher), data = _a.data, error = _a.error, mutate = _a.mutate;
    return {
        setState: mutate,
        nutsCodes: data,
        isLoadingNuts: !error && !data,
        isErrorFetchingNuts: error,
    };
};
